import React, { useEffect } from 'react';
import { initMetaPixel } from '../utils/metaPixel';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { LeadSection } from '../components/LeadSection';
import { AgitationSection } from '../components/AgitationSection';
import { AvatarSection } from '../components/AvatarSection';
import { FailedSolutionsSection } from '../components/FailedSolutionsSection';
import { MechanismSection } from '../components/MechanismSection';
import { ProductSection } from '../components/ProductSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForWhomSection } from '../components/ForWhomSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { AnimatedWaves } from '../components/AnimatedWaves';
import { RecentPurchasePopup } from '../components/RecentPurchasePopup';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-dark-bg text-text-primary relative selection:bg-gold/30 selection:text-gold overflow-hidden" data-id="element-286">
      <div className="bg-waves" data-id="element-287"></div>
      <AnimatedWaves data-id="element-288" />
      <Navbar data-id="element-289" />
      <main className="relative z-10" data-id="element-290">
        <HeroSection data-id="element-291" />
        <LeadSection data-id="element-292" />
        <AgitationSection data-id="element-293" />
        <AvatarSection data-id="element-294" />
        <FailedSolutionsSection data-id="element-295" />
        <MechanismSection data-id="element-296" />
        <ProductSection data-id="element-297" />
        <TestimonialsSection data-id="element-298" />
        <ForWhomSection data-id="element-299" />
        <PricingSection data-id="element-300" />
        <FAQSection data-id="element-301" />
      </main>
      <Footer data-id="element-302" />
      <RecentPurchasePopup data-id="element-303" />
    </div>;
}